import React          from 'react';
import EggBox         from './EggBox';
import sizes          from 'utils/sizes';
import { makeStyles } from "makeStyles";
import { objType }    from 'types';

//var clsx = require('classnames')

const useStyles = makeStyles()(() => ({    
    root: {
        transition: 'transform 0.4s',
        display:    'flex'
    },
    unit: {
       cursor:          'pointer',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       zIndex:          1
    }
})
);

type GridProps = {
    size:          number[];
    range:         number;
    pageNum:       number;
    tensVal:       number;
    resetPos:      boolean;
    wideScreen:    boolean;
    droppablePos0: objType;
    droppablePos1: objType;
}

const Grid: React.FC<GridProps> = ({ 
    size,
    range,
    pageNum,
    tensVal,
    resetPos,
    wideScreen,
    droppablePos0,
    droppablePos1,
 }) => {

  const { classes } = useStyles();

  const [rootStyle, unitStyle] = React.useMemo(() => {

      const { bigBoxWidth, bigBoxHeight, smallBoxHeight } = sizes;
      const width = wideScreen ? bigBoxWidth : '19vw'

      return[
          {
          //   height: wideScreen ? undefined : 200,
             width:          wideScreen ? undefined : '100vw',
             flexFlow:       wideScreen ? 'column' : 'row',
             alignItems:     wideScreen ? undefined : 'center',
             justifyContent: wideScreen ? undefined : 'space-evenly',
          },
          {
            width:  width,
            height: wideScreen ? bigBoxHeight : smallBoxHeight,
          }
      ]
  },[wideScreen])

  return (
        <div 
            className = { classes.root }
            style     = { rootStyle }
        >
            {
                new Array(5).fill(0).map((val, ind) => {
                    return (
                        <div 
                           key       = { `exercises_solutions${ ind }` }
                           className = { classes.unit }
                           style     = { unitStyle }
                        >
                            {
                                wideScreen &&
                                <EggBox
                                   wideScreen    = { wideScreen }
                                   droppablePos0 = { droppablePos0 }
                                   droppablePos1 = { droppablePos1 }
                                   value         = { ind + range }
                                   pageNum       = { pageNum }
                                   tensVal       = { tensVal }
                               />
                            }
                            {
                                !wideScreen &&
                                <EggBox
                                   wideScreen    = { wideScreen }
                                   droppablePos0 = { droppablePos0 }
                                   droppablePos1 = { droppablePos1 }
                                   value         = { ind + range }
                                   pageNum       = { pageNum }
                                   tensVal       = { tensVal }
                               />
                            }
                        </div>
                    )
                })
            }
        </div>
  );
}



export default Grid;








